<template>
  <organism-discovery
    :hasCredential="hasCredential"
    :hasBackup="hasBackup"
    :totalCount="totalCount"
    :fields="fields"
    :discoveryList="discoveryList"
    :sshCredentialOptions="sshCredentialOptions"
    :autoBackupCommandOptions="autoBackupCommandOptions"
    :tagOptions="tagOptions"
    @searchBySubnet="searchBySubnetFromApi"
    @addEquipment="addEquipmentByApi"
  ></organism-discovery>
</template>

<script>
import {
  getCredentialsList,
  getAutoBackupConfigList,
  discoveryBySubnet,
  getTagsList,
  addNodes,
} from "@/api/api-module4"
import mixins from "@/mixins"
import OrganismDiscovery from "@/components/organisms/networkConfigurationManagement/OrganismDiscovery.vue"

export default {
  name: "Discovery",
  components: { OrganismDiscovery },
  mixins: [mixins],
  data() {
    return {
      hasSnmp: false,
      hasSsh: false,
      hasBackup: false,

      totalCount: 0,

      fields: [
        {
          field: "nodeName",
          label: "NODE NAME",
          sortable: true,
        },
        {
          field: "ipAddress",
          label: "IP ADDRESS",
          sortable: true,
        },
        {
          field: "description",
          label: "DESCRIPTION",
          sortable: false,
        },
        {
          field: "sshCredential",
          label: "SSH CREDENTIAL",
          sortable: false,
        },
        {
          field: "autoBackupCommand",
          label: "AUTO BACKUP COMMAND",
          sortable: false,
        },
      ],
      discoveryList: [],

      sshCredentialOptions: null,
      autoBackupCommandOptions: null,

      tagOptions: ["Server", "VM"],
    }
  },
  computed: {
    isLoading() {
      return !this.sshCredentialOptions || !this.autoBackupCommandOptions
    },

    hasCredential() {
      return this.hasSnmp && this.hasSsh
    },
  },
  watch: {},
  created() {
    this.getDataFromApi()
  },
  methods: {
    async getDataFromApi() {
      await Promise.all([
        this.checkSnmpCredentialsIsExits(),
        this.getSshCredentialsListFromApi(),
        this.getAutoBackupConfigListFromApi(),
        this.getTagsListFromApi(),
      ])
      this.totalCount = 0
      this.discoveryList = []
    },

    async searchBySubnetFromApi(subnet) {
      this.showLoading(true)
      this.discoveryList = []
      await discoveryBySubnet(subnet)
        .then((equipments) => {
          this.totalCount = equipments.length

          equipments.forEach((equipment) => {
            this.discoveryList.push({
              nodeName: equipment.hostname,
              ipAddress: equipment.ipAddress,
              description: equipment.description,
              sshCredential: null,
              autoBackupCommand: null,
              snmpCredentialId: equipment.snmpCredentialId,
            })
          })
          if (!equipments.length) {
            this.toastError("Node not found")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async addEquipmentByApi(addEquipment) {
      this.showLoading(true)
      await addNodes(addEquipment)
        .then(async (response) => {
          if (response.status === "ok") {
            this.toastSuccess("Equipment added successfully")

            await this.$router.push({
              name: "networkConfigurationNodeManagement",
            })
          } else {
            this.toastError("Equipment added failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    async checkSnmpCredentialsIsExits() {
      this.showLoading(true)
      this.hasSnmp = false

      // get data from api
      await getCredentialsList("snmp")
        .then((response) => {
          this.hasSnmp = response.totalCount > 0
        })
        .finally(() => this.showLoading(false))
    },

    async getSshCredentialsListFromApi() {
      this.showLoading(true)
      this.hasSsh = false
      this.sshCredentialOptions = []

      // get data from api
      await getCredentialsList("remote")
        .then((response) => {
          this.hasSsh = response.totalCount > 0

          response.data.forEach((ssh) => {
            this.sshCredentialOptions.push({
              id: ssh.credentialId,
              name: ssh.credentialName,
            })
          })
        })
        .finally(() => this.showLoading(false))
    },

    async getAutoBackupConfigListFromApi() {
      this.showLoading(true)
      this.hasBackup = false
      this.autoBackupCommandOptions = []

      // get data from api
      await getAutoBackupConfigList()
        .then((response) => {
          this.hasBackup = response.totalCount > 0

          response.data.forEach((backup) => {
            this.autoBackupCommandOptions.push({
              id: backup.autoBackupConfigId,
              name: backup.autoBackupConfigName,
            })
          })
        })
        .finally(() => this.showLoading(false))
    },

    async getTagsListFromApi() {
      this.showLoading(true)
      this.tagOptions = []

      await getTagsList()
        .then((tags) => {
          this.tagOptions = tags
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped></style>
